import { translate } from 'react-translate'
import ModalActions from './modal-actions'

export default translate('MasterModal')(ModalActions)

